import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import type { GroupBy } from "../utils/period";
import type { QueryOpts } from "./useTrackingEvents";

export interface AggregateBucket {
	bucket: string;
	count: number;
	distinct_user_count: number | null;
}

export interface AggregateResponse {
	event: string;
	group_by: string;
	from: string;
	to: string;
	data_source: "raw" | "rollup";
	buckets: AggregateBucket[];
}

export interface AggregateArgs {
	event: string;
	from: Date;
	to: Date;
	groupBy: GroupBy;
}

const fetchAggregate = async (
	args: AggregateArgs
): Promise<AggregateResponse> => {
	const { data } = await cmsClient.get<AggregateResponse>(
		"/tracking/aggregate/",
		{
			params: {
				event: args.event,
				from: args.from.toISOString(),
				to: args.to.toISOString(),
				group_by: args.groupBy
			}
		}
	);
	return data;
};

const useTrackingAggregate = (args: AggregateArgs, options?: QueryOpts) =>
	useQuery(
		[
			"tracking",
			"aggregate",
			args.event,
			args.from.toISOString(),
			args.to.toISOString(),
			args.groupBy
		],
		() => fetchAggregate(args),
		{ enabled: !!args.event && (options?.enabled ?? true) }
	);

export default useTrackingAggregate;
